import { formatNumber } from '@helpers/FormatHelper'

export default formatNumber
